import { useAppTheme } from "@hooks/useAppTheme";
import { ScrollView } from "react-native";
import { Text } from "react-native-paper";
import ButtonGrid from "./components/ButtonGrid";
import Display from "./components/Display";
import { UI_TEXT } from "./constants";
import { useE6BCalculator } from "./hooks/useE6BCalculator";

const E6BCalculator = () => {
	const { state, handlers } = useE6BCalculator();
	const theme = useAppTheme();

	return (
		<ScrollView
			style={{ flex: 1 }}
			contentContainerStyle={{
				padding: 16,
				gap: 4,
				minHeight: "100%",
				backgroundColor: theme.palette.calculator.background,
			}}
			showsVerticalScrollIndicator={false}
		>
			<Display
				display={state.display}
				mode={state.mode}
				selectedIndex={state.selectedIndex}
				input={state.input}
				result={state.result}
				previousValue={state.previousValue}
				operation={state.operation}
				memory={state.memory}
				isTimerRunning={state.isTimerRunning}
				timerSeconds={state.timerSeconds}
			/>
			<Text variant="bodyMedium" style={{ textAlign: "center", fontSize: 8 }}>
				{UI_TEXT.CALCULATOR_TITLE}
			</Text>

			<ButtonGrid
				onModeChange={handlers.handleModeChange}
				onNavigationPress={handlers.handleNavigationPress}
				onOperatorPress={handlers.handleOperatorPress}
				onNumberPress={handlers.handleNumberPress}
				onMathOperation={handlers.handleMathOperation}
				onMemoryOperations={handlers.handleMemoryOperations}
				onTimer={handlers.handleTimer}
				onCalculation={handlers.performCalculation}
				onUnitOperations={handlers.handleUnitOperations}
			/>
		</ScrollView>
	);
};

export default E6BCalculator;
